var _g, _g2, _path, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaintbrush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_715_14740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.969 2.96947C23.7177 1.97492 25.1328 1.77962 26.123 2.53419C27.0642 3.25149 27.287 4.5763 26.632 5.56195L15.0444 23.0006L10.3438 19.7394L22.969 2.96947Z",
    fill: "url(#paint0_linear_715_14740)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_715_14740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0045 28.9244C13.3272 28.2353 14.2305 26.8516 14.2305 25.2568C14.2305 22.9743 12.3801 21.124 10.0977 21.124C7.81519 21.124 5.96484 22.9743 5.96484 25.2568C5.96484 25.666 6.02429 26.0612 6.13501 26.4344C6.26648 27.0686 6.26782 28.1032 5.5473 28.7084C5.4173 28.8176 5.32422 28.9711 5.32422 29.1409C5.32422 29.3578 5.46857 29.5484 5.68048 29.5945C7.84829 30.0656 10.0501 30.0903 12.0045 28.9244Z",
    fill: "url(#paint1_radial_715_14740)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0045 28.9244C13.3272 28.2353 14.2305 26.8516 14.2305 25.2568C14.2305 22.9743 12.3801 21.124 10.0977 21.124C7.81519 21.124 5.96484 22.9743 5.96484 25.2568C5.96484 25.666 6.02429 26.0612 6.13501 26.4344C6.26648 27.0686 6.26782 28.1032 5.5473 28.7084C5.4173 28.8176 5.32422 28.9711 5.32422 29.1409C5.32422 29.3578 5.46857 29.5484 5.68048 29.5945C7.84829 30.0656 10.0501 30.0903 12.0045 28.9244Z",
    fill: "url(#paint2_radial_715_14740)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0045 28.9244C13.3272 28.2353 14.2305 26.8516 14.2305 25.2568C14.2305 22.9743 12.3801 21.124 10.0977 21.124C7.81519 21.124 5.96484 22.9743 5.96484 25.2568C5.96484 25.666 6.02429 26.0612 6.13501 26.4344C6.26648 27.0686 6.26782 28.1032 5.5473 28.7084C5.4173 28.8176 5.32422 28.9711 5.32422 29.1409C5.32422 29.3578 5.46857 29.5484 5.68048 29.5945C7.84829 30.0656 10.0501 30.0903 12.0045 28.9244Z",
    fill: "url(#paint3_linear_715_14740)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_715_14740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.242 3.82178L13.3828 20.4389",
    stroke: "url(#paint4_linear_715_14740)",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0395 18.4965C11.1683 18.3171 11.4183 18.2761 11.5977 18.405L15.8339 21.4476C16.0133 21.5765 16.0543 21.8264 15.9254 22.0059L14.8511 23.5015C14.529 23.9501 13.9041 24.0525 13.4556 23.7303L10.194 21.3877C9.74548 21.0656 9.64303 20.4407 9.96521 19.9922L11.0395 18.4965Z",
    fill: "#9E98A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0395 18.4965C11.1683 18.3171 11.4183 18.2761 11.5977 18.405L15.8339 21.4476C16.0133 21.5765 16.0543 21.8264 15.9254 22.0059L14.8511 23.5015C14.529 23.9501 13.9041 24.0525 13.4556 23.7303L10.194 21.3877C9.74548 21.0656 9.64303 20.4407 9.96521 19.9922L11.0395 18.4965Z",
    fill: "url(#paint5_linear_715_14740)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0395 18.4965C11.1683 18.3171 11.4183 18.2761 11.5977 18.405L15.8339 21.4476C16.0133 21.5765 16.0543 21.8264 15.9254 22.0059L14.8511 23.5015C14.529 23.9501 13.9041 24.0525 13.4556 23.7303L10.194 21.3877C9.74548 21.0656 9.64303 20.4407 9.96521 19.9922L11.0395 18.4965Z",
    fill: "url(#paint6_linear_715_14740)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0395 18.4965C11.1683 18.3171 11.4183 18.2761 11.5977 18.405L15.8339 21.4476C16.0133 21.5765 16.0543 21.8264 15.9254 22.0059L14.8511 23.5015C14.529 23.9501 13.9041 24.0525 13.4556 23.7303L10.194 21.3877C9.74548 21.0656 9.64303 20.4407 9.96521 19.9922L11.0395 18.4965Z",
    fill: "url(#paint7_linear_715_14740)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0395 18.4965C11.1683 18.3171 11.4183 18.2761 11.5977 18.405L15.8339 21.4476C16.0133 21.5765 16.0543 21.8264 15.9254 22.0059L14.8511 23.5015C14.529 23.9501 13.9041 24.0525 13.4556 23.7303L10.194 21.3877C9.74548 21.0656 9.64303 20.4407 9.96521 19.9922L11.0395 18.4965Z",
    fill: "url(#paint8_radial_715_14740)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0395 18.4965C11.1683 18.3171 11.4183 18.2761 11.5977 18.405L15.8339 21.4476C16.0133 21.5765 16.0543 21.8264 15.9254 22.0059L14.8511 23.5015C14.529 23.9501 13.9041 24.0525 13.4556 23.7303L10.194 21.3877C9.74548 21.0656 9.64303 20.4407 9.96521 19.9922L11.0395 18.4965Z",
    fill: "url(#paint9_radial_715_14740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_715_14740",
    x: 10.3438,
    y: 2.07471,
    width: 17.4141,
    height: 20.9259,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.286275 0 0 0 0 0.360784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_715_14740",
    x: 5.32422,
    y: 21.124,
    width: 9.40625,
    height: 8.77393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.466667 0 0 0 0 0.262745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_14740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_715_14740",
    x: 11.5078,
    y: 1.94678,
    width: 15.6094,
    height: 20.3672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_715_14740"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_14740",
    x1: 25.9043,
    y1: 2.07471,
    x2: 15.1543,
    y2: 18.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9309C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF355A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_14740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.543 23.6172) rotate(126.983) scale(6.33751 5.38645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169422,
    stopColor: "#FFD060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9452"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_715_14740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.99811 23.625) rotate(82.9189) scale(6.32116 8.89957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.723529,
    stopColor: "#FF836A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_14740",
    x1: 12.4044,
    y1: 22.3125,
    x2: 11.7794,
    y2: 23.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245714,
    stopColor: "#FCA94C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA94C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_14740",
    x1: 25.242,
    y1: 3.32468,
    x2: 13.3828,
    y2: 19.9418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF65C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_715_14740",
    x1: 11.6425,
    y1: 22.8179,
    x2: 12.4237,
    y2: 21.7172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0865052,
    stopColor: "#9A7F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A7F86",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_715_14740",
    x1: 10.3288,
    y1: 19.2317,
    x2: 13.0983,
    y2: 21.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12496,
    stopColor: "#7F7D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7D80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_715_14740",
    x1: 15.6548,
    y1: 23.9182,
    x2: 13.5244,
    y2: 22.2142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE7FCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE7FCD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_715_14740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4831 19.5157) rotate(129.906) scale(3.72734 3.36182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A199A9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_715_14740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4831 19.7288) rotate(128.234) scale(1.4917 2.76943)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.174504,
    stopColor: "#B9B0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B0C3",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintbrush);
export default __webpack_public_path__ + "static/media/Paintbrush.16337e2faae483445f0a7ecbb7b354dc.svg";
export { ForwardRef as ReactComponent };